<script setup lang="ts">
  import { useOfflineStatus } from '@/composables/useOfflineStatus'
  const isOffline = useOfflineStatus()
</script>

<template>
  <div v-if="isOffline" class="offline-indicator"><i class="fas fa-wifi-slash"></i> You are currently offline</div>
</template>

<style lang="sass">
  .offline-indicator
    background-color: theme('colors.juss.purple.50')
    color: theme('colors.juss.purple.700')
    padding: 0.5rem
    text-align: center
    font-size: 0.9rem
    font-weight: 600
    width: 100%
    margin-top: -1.45rem
</style>
